module.exports = __webpack_public_path__ + "img/share-invite-team-svg.a08dc09c.svg";